export const selectTeamDetails = (state) => state.teamDetails;
